<template>
  <!-- 投票详情管理 -->
  <div class="page-container">
    <!-- 导航栏 -->
    <!-- 数据卡片 -->
    <div class="page-card">
      <!-- 搜索栏 -->
      <div class="page-card__header">
        <el-row>
          <el-col :span="6">
            <span style="padding-right: 20px"> 投票详情（共{{ aSum }}条）</span>
          </el-col>
          <el-col :span="6">
            <el-input v-model="input">
              <el-button
                slot="append"
                icon="el-icon-search"
                @click="serach"
              ></el-button>
            </el-input>
          </el-col>
        </el-row>
      </div>
      <!-- 表格内容 -->
      <div class="page-card__body">
        <el-table :data="tableData" style="width: 100%">
          <el-table-column prop="id" label="ID" width="80px"></el-table-column>
          <el-table-column prop="exh_name" label="展会名称"></el-table-column>
          <el-table-column
            prop="phone_number"
            label="手机号码"
          ></el-table-column>
          <el-table-column prop="selected" label="服务">
          </el-table-column>

          <el-table-column
            prop="create_time"
            label="填写时间"
            width="160"
            sortable
          ></el-table-column>

          <el-table-column label="操作">
            <template slot-scope="scope">
              <el-button
                type="text"
                @click="handleClick(scope.row)"
              >删除</el-button>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>

    <!-- 分页 -->
    <div class="pagination-wrap">
      <el-pagination
        @current-change="handleCurrentChange"
        :page-size="pagesize"
        :total="aSum"
        :page-count="pageCount"
        :current-page.sync="currentPage"
        background
        layout="prev, pager, next,jumper"
      >
      </el-pagination>
    </div>
  </div>
</template>

<script>
import api from "../../utils/api";

export default {
  name: "cnThaList",
  data() {
    return {
      tableData: [],
      pageCount: 1,
      // 每页显示条目数 pagesize
      pagesize: 10,
      currentPage: 1,
      aSum: 0,
      input: "",
    };
  },
  mounted() {
    // 页面加载时获取数据
    this.getData();
  },
  methods: {
    // 获取投票详情列表数据
    getData() {
      let url = this.baseUrl + "/admin/survey/";
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },
    // 搜索投票记录
    serach() {
      let url =
        this.baseUrl +
        "/admin/survey/?search=" +
        this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = 1;
      });
    },

    // 分页切换
    handleCurrentChange(val) {
      let url =
        this.baseUrl +
        "/admin/survey/?page=" +
        val +
        "&search=" +
        this.input;
      api.fetchData(url).then((res) => {
        this.tableData = res.results;
        this.aSum = res.count;
        this.currentPage = val;
      });
    },

    // 删除投票记录
    handleClick(row) {
      this.$confirm("将删除此条信息，是否继续", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(() => {
        let a_id = row.id;
        let url = this.baseUrl + "/admin/survey/" + a_id + "/";
        api.deleteData(url).then((res) => {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getData();
        });
      });
    },
  },
};
</script>

<style scoped>
::v-deep .vue-html5-editor > .content {
  max-height: 600px;
}
</style>



// WEBPACK FOOTER //
// src/components/admin/survey_other.vue